import type { Organization } from '@/api/Organization';
import type { OrganizationSettingsUpdate } from '@/api/OrganizationSettingsUpdate';
import type { SignupRequest } from '@/api/SignupRequest';
import type { SignupResponse } from '@/api/SignupResponse';
import apiClient from './core/ApiClient';

export interface SettingsEntry {
    name: string;
    country: string;
    city: string;
}

const signup = (company: string, email: string, password: string, firstName: string, lastName: string, captcha?: string, settings?: { currency: string; country: string; city?: string }): Promise<SignupResponse> => {
    const payload: SignupRequest = {
        company,
        email,
        password,
        firstName,
        lastName,
        captcha: captcha ?? null,
        currency: settings?.currency ?? "CHF",
        country: settings?.country ?? "CH",
        city: settings?.city?.trim() || null
    };
    return apiClient.post<SignupRequest, SignupResponse>('/api/organizations/signup', payload);
};

export const organizationService = {
    signup,
    listAll: (): Promise<Organization[]> => apiClient.get<Organization[]>('/api/organizations'),
    current: (token?: string): Promise<Organization> =>
        apiClient.get<Organization>('/api/organizations/current', token),
    updateSettings: (settings: SettingsEntry): Promise<Organization> =>
        apiClient.put<OrganizationSettingsUpdate, Organization>('/api/organizations/current', {
            name: settings.name.trim(),
            country: settings.country,
            city: settings.city?.trim() || null,
        }).catch(apiClient.handleError<Organization>),
};
